import type { SubscriptionMe } from '../model/subscription.types';

export function isCheckoutSettling(
    subscription: Pick<SubscriptionMe, 'externalCheckoutSessionId'> | null | undefined,
    checkoutSessionId: string | undefined,
): boolean {
    if (!checkoutSessionId) return false;
    return subscription?.externalCheckoutSessionId !== checkoutSessionId;
}
